<template>
  <a
    class="director-block"
    :href="hrefLink"
  >
    <span
      v-show="collapsed"
      class="director-block--inner"
      data-event-category="discover"
      data-event-action="info"
      :data-event-label="director.name"
    >
      <div
        class="collaborator-detail-wrapper"
      >
        <span>
          <profile-picture-initial
            :src="profileImageUrl"
            :size="92"
          />
        </span>
        <div>
          <span
            class="stylized director-block__name"
          >{{ director.name }}</span>
          <span
            class="stylized director-block__role"
          >
            <!--
            Regex for capitalize and replace special char with space
            TODO: simplify the regex or make helper function for it
            -->
            {{ role.replace(/(?:^|\s|[-"'([{])+\S/g, (c) => c.toUpperCase()).replace(/[^a-zA-Z ]/g, " ") }}</span>
        </div>
      </div>
    </span>
    <div
      v-show="!collapsed && index<5"
    >
      <profile-picture-initial
        :name="director.name"
        :src="profileImageUrl"
        :size="24"
      />
    </div>
  </a>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ProfilePictureInitial from '@/scripts/Components/Molecules/ProfilePictureInitial.vue';
import userResponseProcessor from '@/scripts/libs/login/userResponseProcessor';
import { Model } from '@viddsee/server-api-client';

interface ComponentData {
  hoverTimeout?: number;
  expand: boolean;
}

export default Vue.extend({
  components: {
    ProfilePictureInitial,
  },
  props: {
    director: {
      type: Object as PropType<Model.Video.Collaborator.ProfileSnippet>,
      required: true,
    },
    role: {
      type: String as PropType<Model.Video.Collaborator.Role>,
      required: true,
    },
    collapsed: Boolean,
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      hoverTimeout: undefined,
      expand: false,
    };
  },
  computed: {
    profileImageUrl(): string {
      return userResponseProcessor.normalizeImage(72, this.director.profileImageUrl, this.director.name);
    },
    hrefLink(): string {
      return (this.director.hasProfile)
        ? `/u/${this.director.vanity}`
        : `/search?search_term=${encodeURIComponent(this.director.name)}`;
    },
  },
});
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.director-block--inner {
  display: inline-block;
  flex-direction: row;
  margin-right: 16px;
  margin-bottom: 4px;
}
.director-block__name {
  display: block;
  font-size: 1em;
  font-weight: $font-weight-bold;
  margin-left: 8px;
  margin-top: 4px;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media(max-width: 1480px) {
    max-width: 92px;
  }
  @media(max-width: 768px) {
    max-width: 55vw
  }
}
.director-block__role {
  display: block;
  font-size: 1em;
  font-weight: $font-weight-light;
  margin-left: 8px;
  max-width: 180px;
  white-space: normal;
  @media(max-width: 990px) {
    max-width: 92px;
  }
  @media(max-width: 768px) {
    max-width: 100%;
    white-space: nowrap;
  }
}

.director-block--inner .profile-picture-initial img {
  box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.4);
  transform: scale(0.40);
  margin: -24px -28px;

}

.director-block--inner {
  position: relative;
  border-radius: 30px;
  transition: transform 0.2s,
              background-color 0.2s,
              box-shadow 0.2s;
  margin: 0 -6px;
  padding: 4px 12px;
}
.director-block--inner:hover {
  z-index: 1;
  background-color: rgba(248, 248, 248, 0.95);
  box-shadow: 1px 1px 1px rgba(0,0,0,0.2);
}

.director-block {
  display: inline-block;
  position: relative;
  transition: transform 0.2s;
}
.director-block:active {
  transform: translateY(1px);
}
.collaborator-detail-wrapper {
  display: flex;
  max-width: 212px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
  @media(max-width: 768px) {
    max-width: 65vw;
  }
}
</style>
